<template>
    <div class="board" style="position:relative">
        <div class="title">
            <span class="name">{{ arrangementTextConfig.title }}</span>
            <!--v-hasPermi="['arrangement:save']"-->
            <el-button  type="primary" @click="$router.push({name:'editExam'})">
                {{ arrangementTextConfig.add }}</el-button>
        </div>
        <paper-config v-hasPermi="['arrangement:exam:list']" ref="paperConfig"
                      :examPlanOptions="examPlanOptions"
                      :subjectOptions="subjectOptions"
                      :examPaperStatusOptions="examPaperStatusOptions"></paper-config>
        <!--<el-tabs v-else v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="arrangementTextConfig.arrangeExam.name" name="0" v-hasPermi="['arrangement:examinee:list']">
                <arrange-exam v-if="activeName==0" ref="arrangeExam"
                              :examPlanOptions="examPlanOptions"
                              :certificateOptions="certificateOptions"
                              :certificateGradeOptions="certificateGradeOptions"
                              :subjectOptions="subjectOptions"
                              :arrangeExamStatusOptions="arrangeExamStatusOptions"
                              :examPaperStatusOptions="examPaperStatusOptions"
                              :examTypeOptions="examTypeOptions"></arrange-exam>
            </el-tab-pane>
            <el-tab-pane :label="arrangementTextConfig.paperConfig.name" name="1" v-hasPermi="['arrangement:exam:list']">
                <paper-config v-if="activeName==1" ref="paperConfig"
                              :examPlanOptions="examPlanOptions"
                              :subjectOptions="subjectOptions"
                              :examPaperStatusOptions="examPaperStatusOptions"></paper-config>
            </el-tab-pane>
        </el-tabs>-->
        <!--<el-button v-hasPermi="['arrangement:save']" @click="importDialogVisible = true" type="primary"
                   v-show="activeName === '0'" style="position:absolute;right:20px;top:20px;">{{ arrangementTextConfig.arrangeExam.import.btnName }}
        </el-button>-->
        <!--<import-dialog :show.sync="importDialogVisible" @close="close"></import-dialog>-->
        <!-- <edit-dialog :row="row" :show.sync="editDialogVisible" @close="close"></edit-dialog> -->
    </div>
</template>
<script>
/*import arrangeExam from './component/arrangeExam.vue'*/
import paperConfig from './component/paperConfig.vue'
// import importDialog from '../dialog/importExam.vue'
// import pagination from '@/components/pagination/pagination.vue'
export default {
    components: {
        paperConfig
    },
    data() {
        return {
            activeName: '0',
            importDialogVisible: false,
            examPlanOptions: [],
            certificateOptions: [],
            certificateGradeOptions: [],
            subjectOptions: [],
            arrangeExamStatusOptions: [],
            examPaperStatusOptions: [],
            examTypeOptions: [],
        };
    },
    computed: {
        arrangementTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement
        }
    },
    methods: {
        handleClick(tab, event) {
        },
        close(data) {
            this.importDialogVisible = false
            if (data) {
                this.getData()
                this.$refs.arrangeExam.search(1)
            }
        },
        getData() {
            this.$store.dispatch("getExamPlan").then(res => {
                this.examPlanOptions = res.data
            });
            this.$store.dispatch("getExamCertificate").then(res => {
                this.certificateOptions = res.data
            });
            this.$store.dispatch("getDict", 'credential_level').then(res => {
                this.certificateGradeOptions = res.data
            });
            this.$store.dispatch("getExamSubject").then(res => {
                this.subjectOptions = res.data
            });
            this.$store.dispatch("getDict", 'arrangement_exam_status').then(res => {
                this.arrangeExamStatusOptions = res.data
            });
            this.$store.dispatch("getDict", 'arrangement_paper_status').then(res => {
                this.examPaperStatusOptions = res.data
            });
            this.$store.dispatch("getDict", 'exam_category').then(res => {
                this.examTypeOptions = res.data
            });
        }
    },
    created() {
        this.getData()
    },
};
</script>
<style scoped>
.el-tabs >>> .el-tabs__header {
    margin-bottom: 19px;
}

.el-tabs >>> .el-tabs__nav .el-tabs__item {
    padding: 15px 0;
    line-height: 36px;
    height: 63px;
    font-weight: 600;
    font-size: 16px;
    padding-right: 20px;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
    height: 1px;
}
</style>